// enum scheduleType {
//   LEADTIMES = "leadtimes",
//   RULES = "rules",
// }

interface ISlotsHelper {
  initial: string
  final: string
}

const slotsHelper = (schedules: any, _sg: any): ISlotsHelper => {
  // const deliveryType = _sg?.deliveryType
  // const logisticPlan = _sg?.logisticPlan
  const slotDelivery = _sg?.slotDelivery

  // const isExpress = Boolean(deliveryType === "EXPRESS")
  // const currentSchedule = schedules?.find((schedule: any) => schedule?.id === deliveryType)

  // const isLeadTime = Boolean(currentSchedule?.type === scheduleType.LEADTIMES)

  // if (isExpress && isLeadTime) {
  //   return {
  //     initial: logisticPlan?.baseDate,
  //     final: logisticPlan?.delivery,
  //   }
  // }

  // if (isExpress && !isLeadTime) {
  //   return {
  //     initial: slotDelivery?.initialHour,
  //     final: slotDelivery?.finalHour,
  //   }
  // }

  return {
    initial: slotDelivery?.initialHour,
    final: slotDelivery?.finalHour,
  }
}

export default slotsHelper